"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const React = __importStar(require("react"));
const merlin_modal_1 = require("@travelnest/merlin.modal");
const Modal = (props) => {
    // When a <Modal> is removed from being rendered, it doesn't
    // remove the className from the <body> (as it does when the close callback is fired):
    // https://github.com/TravelNest/merlin/blob/master/components/modal/src/Modal.tsx#L18
    React.useEffect(() => {
        return () => {
            var _a;
            // TODO: Magic string from Merlin's Modal, could be exported by the component, or this could be done inline
            (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.remove('merlin-modal-body');
        };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(merlin_modal_1.Modal, Object.assign({}, props), props.children));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map